import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { adminApi, errText, fmtDate } from "./api";

export default function Settings() {
  const { user } = useOutletContext();
  const [saving, setSaving] = useState(false);

  const changePassword = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = Object.fromEntries(new FormData(form));
    if (data.new_password !== data.confirm_password) {
      toast.error("New passwords do not match.");
      return;
    }
    setSaving(true);
    try {
      await adminApi.post("/auth/change-password", {
        current_password: data.current_password,
        new_password: data.new_password,
      });
      toast.success("Password updated. Use the new password next time you sign in.");
      form.reset();
    } catch (err) {
      toast.error(errText(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-settings">
      <div className="admin-page-head">
        <h1>Settings</h1>
        <p>Your admin account and session details.</p>
      </div>
      <section className="admin-panel">
        <h2>Account</h2>
        <div className="settings-grid">
          <div><span>Email</span><strong data-testid="settings-email">{user.email}</strong></div>
          <div><span>Role</span><strong>{user.role}</strong></div>
          <div><span>Account created</span><strong>{fmtDate(user.created_at)}</strong></div>
          <div><span>Session</span><strong>Secure cookie · signs out after 24 hours</strong></div>
        </div>
      </section>
      <section className="admin-panel">
        <h2><KeyRound size={16} /> Change password</h2>
        <form className="ts-form" onSubmit={changePassword} data-testid="change-password-form">
          <div className="form-row">
            <label>Current password<input name="current_password" type="password" required data-testid="settings-current-password" /></label>
            <label>New password (min 8 characters)<input name="new_password" type="password" required minLength={8} data-testid="settings-new-password" /></label>
          </div>
          <label>Confirm new password<input name="confirm_password" type="password" required minLength={8} data-testid="settings-confirm-password" /></label>
          <div className="admin-actions">
            <button className="btn btn-primary" type="submit" disabled={saving} data-testid="settings-save-password">{saving ? "Updating…" : "Update password"}</button>
          </div>
        </form>
      </section>
    </div>
  );
}
